
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reconditionne/panier",
      function () {
        return require("private-next-pages/reconditionne/panier/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reconditionne/panier"])
      });
    }
  